import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SubProjectTypesDataGrid } from "src/components/views/erp/project/subProject/subProjectTypes/SubProjectTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/subProjectTypes")({
	staticData: { title: i18n.t("sub_project_types"), legacyViewKey: "subProjectTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SubProjectTypesDataGrid />;
}
